import * as React from 'react';
import { InlineCalendar, InlineCalendarProps } from './InlineCalendar';
import { getUserOptions } from 'owa-session-store';
import { MIN_OUTLOOK_DATE, MAX_OUTLOOK_DATE } from 'owa-datetime/lib/utcDate/outlookDates';
import { observer } from 'mobx-react';

/**
 * An inline date picker that is localized, formats dates according to OWA's date/time formats,
 * observes OWA options on how to show weeks and default to min/max dates supported by Outlook
 */
export const InlineDatePicker = observer(
    ({
        maxDate = MAX_OUTLOOK_DATE,
        minDate = MIN_OUTLOOK_DATE,
        ...formattedalendarProps
    }: Omit<InlineCalendarProps, 'firstDayOfWeek' | 'firstWeekOfYear' | 'showWeekNumbers'>) => {
        const { WeekStartDay, FirstWeekOfYear, ShowWeekNumbers } = getUserOptions();
        return (
            <InlineCalendar
                {...formattedalendarProps}
                maxDate={maxDate}
                minDate={minDate}
                firstDayOfWeek={WeekStartDay}
                firstWeekOfYear={FirstWeekOfYear}
                showWeekNumbers={ShowWeekNumbers}
            />
        );
    }
);
